import IconTemplate from '@components/Icon';
import { rem } from 'polished';
import styled from 'styled-components';
import { IColors } from '../../interfaces/Conference';

export const Wrapper = styled.div`
    padding: ${rem(40)} ${rem(20)} ${rem(15)} ${rem(20)};
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
`;

export const Title = styled.span<{ colors: IColors }>`
    padding-bottom: ${rem(30)};
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    font-size: ${({ theme }) => theme.fontSizes.h4};
    position: relative;
    color: ${(props) => props.colors?.colorTitle};
`;

export const TitleSymbol = styled.span<{ colors: IColors }>`
    position: absolute;
    width: ${rem(40)};
    height: ${rem(5)};
    background: ${(props) => props.colors?.colorLine};
    left: 0;
    bottom: ${rem(15)};
`;

export const Tabs = styled.div`
    display: flex;
    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
    margin-top: ${rem(20)};
    //overflow: scroll;
`;

export const Tab = styled.div<{ colors: IColors }>`
    margin-right: ${rem(30)};
    color: ${(props) => props.colors?.colorLink};
    cursor: pointer;
    //white-space: nowrap;

    &.active {
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        border-bottom: 2px solid ${(props) => props.colors?.colorLink};
        padding-bottom: ${rem(10)};
    }
`;

export const Content = styled.div`
    margin: 0 ${rem(10)};
`;

export const Attachment = styled.div`
    cursor: pointer;
    display: flex;
    padding-bottom: ${rem(5)};
    align-items: center;
`;

export const AttachmentName = styled.a<{ colors: IColors }>`
    cursor: pointer;
    display: flex;
    padding-bottom: ${rem(5)};
    align-items: center;
    color: ${(props) => props.colors?.colorLink};
`;

export const AttachmentIcon = styled(IconTemplate)`
    padding: 0 ${rem(25)} 0 ${rem(10)};

    svg {
        width: ${rem(30)};
        height: ${rem(30)};
    }
`;

export const ButtonDownload = styled.button<{ colors: IColors }>`
    border: none;
    color: ${({ theme }) => theme.colors.white};
    background: ${(props) => props.colors?.colorLink};
    border-radius: ${rem(4)};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    padding: 0 ${rem(40)};
    height: ${rem(45)};
    margin-left: ${rem(75)};
    margin-bottom: ${rem(10)};
    margin-top: ${rem(20)};
    cursor: pointer;
    box-shadow: 0 0 4px ${(props) => props.colors?.colorLink};
`;

export const InfoMessage = styled.span`
    color: ${({ theme }) => theme.colors.primary};
`;
